var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewClientsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 9H5.03423V11H15.0164C15.0055 10.8347 15 10.668 15 10.5C15 9.9863 15.0516 9.48466 15.15 9Z",
    fill: "#3E7EAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4268 13H4.89458L3.96856 14.8792C2.87153 17.1057 2.67487 19 3.54065 19C4.01785 19 4.03851 19.1667 4.03851 23V27H21.9615V23C21.9615 19.1667 21.9821 19 22.4593 19C22.8506 19 23.0248 18.6132 22.9972 17.9838C22.8328 17.9945 22.667 18 22.5 18C19.2345 18 16.4564 15.913 15.4268 13ZM19.97 25V19H6.02995V25H19.97Z",
    fill: "#3E7EAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 10.5C29 14.0899 26.0899 17 22.5 17C18.9101 17 16 14.0899 16 10.5C16 6.91015 18.9101 4 22.5 4C26.0899 4 29 6.91015 29 10.5ZM19 10.5007C19 10.1596 19.2765 9.88306 19.6176 9.88306H21.8824V7.61765C21.8824 7.27653 22.1589 7 22.5 7C22.8412 7 23.1177 7.27653 23.1177 7.61765V9.88306H25.3824C25.7235 9.88306 26 10.1596 26 10.5007C26 10.8418 25.7235 11.1184 25.3824 11.1184H23.1177V13.3824C23.1177 13.7235 22.8412 14 22.5 14C22.1589 14 21.8824 13.7235 21.8824 13.3824V11.1184H19.6176C19.2765 11.1184 19 10.8418 19 10.5007Z",
    fill: "#3E7EAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewClientsIcon);
export default __webpack_public_path__ + "static/media/newClientsIcon.cfec71b3a350e36cfdc042e5baa1db52.svg";
export { ForwardRef as ReactComponent };